Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var React = require('react');
var reactSwipeable = require('react-swipeable');
var cn = require('classnames');
var coreComponentsBaseModal = require('../base-modal');
var shared = require('../navigation-bar-private/shared');
var coreComponentsShared = require('../shared');
var components_backdrop_Component = require('./components/backdrop/Component.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var cn__default = /*#__PURE__*/_interopDefaultCompat(cn);

var styles = {"component":"popup-sheet__component_1weav","closer":"popup-sheet__closer_1weav","content":"popup-sheet__content_1weav","appear":"popup-sheet__appear_1weav","enter":"popup-sheet__enter_1weav","appearActive":"popup-sheet__appearActive_1weav","enterActive":"popup-sheet__enterActive_1weav","exit":"popup-sheet__exit_1weav","exitBySwipe":"popup-sheet__exitBySwipe_1weav","exitActiveBySwipe":"popup-sheet__exitActiveBySwipe_1weav","exitActive":"popup-sheet__exitActive_1weav","exitDone":"popup-sheet__exitDone_1weav"};
require('./index.css');

var SWIPE_VELOCITY = 0.3;
var CLOSE_OFFSET = 0.3;
var ANIMATION_DURATION = 350;
var DEFAULT_PADDING = 32;
var PopupSheet = React.forwardRef(function (_a, ref) {
    var children = _a.children, hasCloser = _a.hasCloser, className = _a.className, onClose = _a.onClose, transitionProps = _a.transitionProps, contentProps = _a.contentProps, swipeable = _a.swipeable, dataTestId = _a.dataTestId, backdropProps = _a.backdropProps, _b = _a.padding, padding = _b === void 0 ? DEFAULT_PADDING : _b, restProps = tslib.__rest(_a, ["children", "hasCloser", "className", "onClose", "transitionProps", "contentProps", "swipeable", "dataTestId", "backdropProps", "padding"]);
    var _c = React.useState(0), sheetOffset = _c[0], setSheetOffset = _c[1];
    var _d = React.useState(1), backdropOpacity = _d[0], setBackdropOpacity = _d[1];
    var sheetHeight = React.useRef(0);
    var sheetRef = React.useRef(null);
    var bySwipeCloseAnimation = React.useRef(false);
    var getSheetOffset = function (deltaY) { return Math.max(0, deltaY); };
    var getBackdropOpacity = function (offset) {
        return Math.max(0, 1 - offset / sheetHeight.current);
    };
    var getSwipeStyles = function () {
        return sheetOffset ? { transform: "translateY(".concat(sheetOffset, "px)") } : {};
    };
    var handleSwiping = function (_a) {
        var deltaY = _a.deltaY;
        var offset = getSheetOffset(deltaY);
        setSheetOffset(offset);
        setBackdropOpacity(getBackdropOpacity(offset));
    };
    var handleSwiped = function (_a) {
        var deltaY = _a.deltaY, velocity = _a.velocity, event = _a.event;
        var shouldCloseByVelocity = deltaY >= 0 && velocity >= SWIPE_VELOCITY;
        var shouldCloseByOffset = deltaY >= sheetHeight.current * CLOSE_OFFSET;
        var offset = sheetOffset;
        var animDuration = ANIMATION_DURATION / 2;
        var start;
        if (shouldCloseByVelocity || shouldCloseByOffset) {
            bySwipeCloseAnimation.current = true;
            onClose === null || onClose === void 0 ? void 0 : onClose(event, 'swipe');
            var runLoop_1 = function (timeStamp) {
                if (!start)
                    start = timeStamp;
                var elapsedTime = timeStamp - start;
                if (elapsedTime <= animDuration) {
                    var nextOffset = offset +
                        (sheetHeight.current - offset) *
                            coreComponentsShared.easingFns.easeInOutQuad(elapsedTime / animDuration);
                    if (nextOffset > 0) {
                        setSheetOffset(nextOffset);
                    }
                    requestAnimationFrame(runLoop_1);
                }
                else {
                    setSheetOffset(0);
                    bySwipeCloseAnimation.current = false;
                }
            };
            requestAnimationFrame(runLoop_1);
        }
        else {
            var runLoop_2 = function (timeStamp) {
                if (!start)
                    start = timeStamp;
                var elapsedTime = timeStamp - start;
                if (elapsedTime <= animDuration) {
                    var nextOffset = offset - offset * coreComponentsShared.easingFns.easeInOutQuad(elapsedTime / animDuration);
                    if (nextOffset > 0) {
                        setSheetOffset(nextOffset);
                        setBackdropOpacity(getBackdropOpacity(nextOffset));
                    }
                    requestAnimationFrame(runLoop_2);
                }
                else {
                    setSheetOffset(0);
                    setBackdropOpacity(1);
                }
            };
            requestAnimationFrame(runLoop_2);
        }
    };
    var handleEntered = function (node, isAppearing) {
        bySwipeCloseAnimation.current = false;
        if (sheetRef.current) {
            sheetHeight.current = sheetRef.current.offsetHeight;
        }
        if (transitionProps === null || transitionProps === void 0 ? void 0 : transitionProps.onEntered) {
            transitionProps.onEntered(node, isAppearing);
        }
    };
    var handleExited = function (node) {
        bySwipeCloseAnimation.current = false;
        setSheetOffset(0);
        setBackdropOpacity(1);
        if (transitionProps === null || transitionProps === void 0 ? void 0 : transitionProps.onExited) {
            transitionProps.onExited(node);
        }
    };
    var sheetSwipeableHandlers = reactSwipeable.useSwipeable({
        onSwiping: handleSwiping,
        onSwiped: handleSwiped,
        trackMouse: swipeable,
        trackTouch: swipeable,
        delta: 5,
    });
    return (React__default.default.createElement(coreComponentsBaseModal.BaseModal, tslib.__assign({}, restProps, { onClose: onClose, ref: ref, className: cn__default.default(styles.component, className), dataTestId: dataTestId, Backdrop: components_backdrop_Component.PopupBackdrop, backdropProps: tslib.__assign(tslib.__assign({}, backdropProps), { opacity: backdropOpacity }), transitionProps: tslib.__assign(tslib.__assign({ classNames: {
                enter: styles.enter,
                appear: styles.appear,
                enterActive: styles.enterActive,
                appearActive: styles.appearActive,
                exit: bySwipeCloseAnimation.current ? styles.exitBySwipe : styles.exit,
                exitActive: bySwipeCloseAnimation.current
                    ? styles.exitActiveBySwipe
                    : styles.exitActive,
            }, timeout: ANIMATION_DURATION }, transitionProps), { onEntered: handleEntered, onExited: handleExited }), componentDivProps: {
            ref: sheetRef,
            style: getSwipeStyles(),
        }, contentProps: tslib.__assign(tslib.__assign(tslib.__assign({ style: coreComponentsShared.createPaddingStyle(padding) }, contentProps), sheetSwipeableHandlers), { className: cn__default.default(styles.content, contentProps === null || contentProps === void 0 ? void 0 : contentProps.className) }) }),
        hasCloser && (React__default.default.createElement(shared.Closer, { view: 'mobile', className: styles.closer, onClick: onClose, dataTestId: coreComponentsShared.getDataTestId(dataTestId, 'closer') })),
        children));
});
PopupSheet.displayName = 'PopupSheet';

exports.PopupSheet = PopupSheet;
